module.exports = __webpack_public_path__ + "static/media/Element_7_treatments.9776f3db.svg";